export function dataInRequest(params = {}) {
  return {
    type: '@justificativaContingencia/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@justificativaContingencia/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@justificativaContingencia/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@justificativaContingencia/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@justificativaContingencia/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@justificativaContingencia/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@justificativaContingencia/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@justificativaContingencia/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@justificativaContingencia/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@justificativaContingencia/RECORD_FILTERING',
    payload: { params },
  };
}
